<template>
<div>
  <router-view></router-view>

  <div class = "section">
    <p class = "title is-1 title-font"> Editar {{type}}</p>
    <a class = "subtitle has-text-link" @click="jumpTo()"> <font-awesome-icon :icon = "['fas', 'arrow-left']"/> Volver </a>
  </div>
  
  <div class = "columns section is-multiline is-centered">

    <div class = "card column is-one-third" v-for="image in images" :key = "image._id">
      <div class = "card-image">
        <figure class="image is-4by3">
          <img :src = "image.displayImage" alt="Placeholder image"/>
        </figure>
      </div>
      <div class = "card-content">
        <a class = "is-size-4" @click = "deleteImage(image._id)"> Borrar imagen </a>
      </div>
    </div>

    <div class = "column is-one-third">
      <div class = "box">
        <div class = "image is-4by3">
          <div class="dropbox has-ratio">

            <div class = "loader-wrapper" :class = "{'is-active': isLoading}">
              <div class = "loader is-loading">

              </div>
            </div>

            <input type="file" ref="fileup"
              accept="image/*" class="is-overlay input-file" @change = "postImage()">
              <p >
                Arrastra tus fotos aquí<br> o haz click para examinar
              </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<script>

import {requester} from '../App.vue';

export default {
  name: 'GalleryEditList',
  data() {
    return { 
      images: [],
      type: "",
      isLoading: false
    }
  },
  methods: {
    jumpTo: function(){
      this.$router.push("/editGallery/")
    },
    postImage: function(){
      let file = this.$refs["fileup"].files[0];
      let token = this.$store.state.token;

      let formData = new FormData();
      formData.append('image', file);
      formData.append('type', this.type);

      this.isLoading = true;

      requester.post('gallery/', formData, {
        headers: {
          token,
          'Content-Type': 'multipart/form-data'
        }
      },
      ).then(() => {
        this.reloadImages();
        this.isLoading = false;
      }).catch(() => {
        alert("La imagen es demasiado pesada o tiene un formato incorrecto. Usa otra imagen");
        this.isLoading = false;
      })
    },
    reloadImages: function(){
        requester.get('gallery/' + this.type,
        ).then((response) => {
          this.images = response.data;
        }).catch(() => {
          
        })
    },
    deleteImage: function(imageId){
      let token = this.$store.state.token;
      requester.delete('gallery/'+imageId, {
        headers: {
          token
        }
      },
      ).then(() => {
        this.reloadImages();
      }).catch(() => {

      })
    }
  },
  mounted: function(){
    this.type = this.$route.params.id;
    this.reloadImages();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "scss" scoped>
.title-font {
  font-family: "Baloo Bhaina 2";
}
h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  position: absolute;
  cursor: pointer;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
font-size: 1.2em;
text-align: center;
padding: 50px 0;
}


.loader-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: #fff;
    opacity: 0;
    z-index: -1;
    transition: opacity .3s;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;

        .loader {
            height: 80px;
            width: 80px;
        }

    &.is-active {
        opacity: 1;
        z-index: 1;
    }
}

</style>